export default __webpack_public_path__ + "static/media/no-7.34f647f3.mp4";